var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_998_47210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0728 0L21.9092 12.1919L25.1009 5.00682L39.0728 0Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.967285 0.0141602L14.9018 5.00753L17.9325 12.2868L0.967285 0.0141602Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1656 25.9287L39.7516 26.0673L37.1004 34.7136L27.8438 32.2669L32.1656 25.9287Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83409 25.9287L12.1399 32.2669L2.89876 34.7138L0.263672 26.0673L7.83409 25.9287Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5203 10.4326L17.8304 20.0451L8.55371 19.64L11.1924 15.8183L11.2258 15.7815L17.5203 10.4326Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3836 10.3257L28.7741 15.7822L28.8072 15.8187L31.446 19.6403L22.1714 20.0454L22.3836 10.3257Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4115 25.9565L17.4768 29.7454L11.5928 32.4726L12.4115 25.9565Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5893 25.9561L28.391 32.4727L22.5234 29.7452L27.5893 25.9561Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6528 29.3882L28.607 32.156L23.0684 34.683L23.1259 33.0128L22.6528 29.3882Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3453 29.3896L16.8908 32.9857L16.9281 34.6812L11.3765 32.1562L17.3453 29.3896Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6263 21.2998L17.1822 24.439L11.8848 22.9493L15.6263 21.2998Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3739 21.3003L28.133 22.9493L22.8184 24.4387L24.3739 21.3003Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8164 25.9248L11.9601 32.6807L7.37061 26.0725L12.8164 25.9248Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1836 25.9248L32.6296 26.0725L28.0228 32.681L27.1836 25.9248Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5799 19.2583L27.6165 23.136L24.5608 21.7954L23.0978 24.748L22.1387 19.6707L31.5799 19.2583Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41797 19.2578L17.8608 19.6702L16.9017 24.7476L15.4384 21.7954L12.3988 23.1356L8.41797 19.2578Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15088 18.4624L12.635 22.8305L12.7904 27.1429L8.15088 18.4624Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8538 18.4546L27.2061 27.1506L27.381 22.8305L31.8538 18.4546Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6417 18.7285L17.8222 19.819L18.2681 22.5356L17.9814 30.8794L16.6259 24.1768L16.6255 24.1075L17.6417 18.7285Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3557 18.7134L23.3746 24.1074L23.3742 24.1767L22.0153 30.8961L21.9615 29.2154L21.7495 22.4861L22.3557 18.7134Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7792 22.6567L27.6275 26.4034L22.8972 29.9415L21.9409 29.2929L23.0128 23.9926L27.7792 22.6567Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2368 22.6567L16.9868 23.9926L18.0587 29.2928L17.1024 29.9415L12.3718 26.4031L12.2368 22.6567Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4717 31.3286L16.5236 34.0814L16.4979 32.9059L17.0043 32.4792H22.994L23.5187 32.9045L23.48 34.0791L29.4935 31.3356L26.5673 33.6569L23.0289 35.99H16.9558L13.4197 33.6474L10.4717 31.3286Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2192 29.022L23.0748 29.6022L23.5763 33.4429L22.8506 32.8547H17.1513L16.4395 33.4548L16.9244 29.6025L17.7804 29.022H22.2192Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9395 0.337402L39.9998 6.27103L38.7131 12.2705L39.6293 12.949L38.3895 13.8571L39.3213 14.5479L38.0875 15.6267L38.8449 16.1533L36.8347 18.4072L28.5894 16.1025L28.5179 16.0657L22.5762 11.2539L37.9395 0.337402Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06031 0.337402L17.4237 11.2539L11.4819 16.0657L11.4105 16.1025L3.16512 18.4072L1.15488 16.1533L1.91176 15.627L0.678517 14.5479L1.60852 13.8579L0.350209 12.9472L1.30098 12.2682L0 6.27125L2.06031 0.337402Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1861 15.5986L36.9226 18.0405L39.7609 26.4383L32.2728 26.4383L27.1133 26.5008L30.8655 19.4796L28.1861 15.5986Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8139 15.5986L9.13399 19.4796L12.8867 26.5008L7.7297 26.4383H0.254883L3.07728 18.0405L11.8139 15.5986Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5288 4.9668L23.0852 11.3026L22.5666 19.8617L22.3682 22.5444L22.3525 29.3976H17.6476L17.6323 22.5573L17.4332 19.8594L16.9144 11.3026L14.4712 4.9668H25.5288Z",
    fill: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_998_47210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetamask);
export default __webpack_public_path__ + "static/media/icon-metamask.b2075df1724a73da0985127fcb3a448a.svg";
export { ForwardRef as ReactComponent };